import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Megaphone, MessageSquare, Handshake, Sparkles, UserCircle } from "lucide-react";

const ITEMS = [
  { to: "/campaigns", label: "Campaigns", icon: Megaphone, match: /^\/campaigns/ },
  { to: "/negotiations", label: "Negotiations", icon: Handshake, match: /^\/negotiations/ },
  { to: "/collabs", label: "Collabs", icon: Sparkles, match: /^\/collabs|^\/deals/ },
  { to: "/messages", label: "Messages", icon: MessageSquare, match: /^\/messages/ },
  { to: "/creator", label: "Profile", icon: UserCircle, match: /^\/creator/ },
];

/**
 * Bottom nav bar for creators.
 * Fixed to viewport bottom, visible below md.
 */
export default function BottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || user.role !== "creator") return null;
  return (
    <>
      <div className="lg:hidden h-16" aria-hidden />
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#060608]/95 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
        data-testid="bottom-nav"
      >
        <div className="grid grid-cols-5">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            const active = it.match.test(pathname);
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={`bottom-nav-${it.label.toLowerCase()}`}
                className={`flex flex-col items-center gap-0.5 py-2.5 transition-colors ${active ? "text-white" : "text-zinc-500 hover:text-zinc-300"}`}
              >
                <div className={`h-1 w-8 rounded-full mb-0.5 ${active ? "nexus-gradient" : "bg-transparent"}`} />
                <Icon className="h-5 w-5" />
                <span className="text-[10px] font-medium tracking-wide">{it.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
